module.exports = __webpack_public_path__ + "static/img/chart.23fdf23c.svg";